import {ArrowLongLeftIcon, ArrowLongRightIcon} from '@heroicons/react/20/solid'
import ReactMarkdown from "react-markdown";
import React from "react";

export default function CenteredPageNumbers({
                                                children,
                                                showPrevious = false,
                                                showSubmit = false,
                                                processing,
                                                form,
                                                submit,
                                                page,
                                                renderRightButton,
                                                renderLeftButton
                                            }) {
    return (
        <nav className="px-4 py-4 bg-white">
            <div className="flex items-center max-w-2xl px-0 justify-evenly mx-auto ">
                <div className={`-mt-px mr-2 md:mr-0 flex flex-grow ${!showPrevious ? 'hidden md:block' : ''}`}>
                    {renderLeftButton?.()}
                </div>
                <div data-cy="pagination-numbers" className="hidden">
                    {children}
                </div>
                <div className={`-mt-px flex md:w-0 flex-grow justify-end`}>
                    {renderRightButton?.()}
                </div>
            </div>
        </nav>
    )
}
